if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');

        this.combinationhandler();
        
      }

      async fetchCombinations(mainSku){
          const query = `
            query GetMetaobjects {
              metaobjects(type: "combinations", first: 100, query:"fields.main_sku:${mainSku}") {
                edges {
                  node {
                    id
                    handle
                    type
                    fields {
                      key
                      value
                    }
                  }
                }
              }
            }
          `;
          const response = await fetch('https://gllite.myshopify.com/api/2025-04/graphql.json', {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": 'ca484a32446c48de98e63ff2d83e4049',
              },
              body: JSON.stringify({ query }),
          });

          const result = await response.json();
          console.log(result);
      }

      combinationhandler(){
        
          let $mainSku = this.querySelector('[data-main-sku]');
          let $addonSku = this.querySelector('[data-addon-sku]');
          let $bottom_addonSku = this.querySelectorAll('[data-addon-sku-bottom]');
          let $combinationModal = document.querySelector('[data-combination-modal]');
          let $combinationModalImage = document.querySelector('[data-combination-image] img');
          let $combinationModalThumbnails = document.querySelector('[data-combination-thumbnails]');
          let $combinationReset = document.querySelector('[data-combination-modal-reset]');
          let $combinationToggle = document.querySelector('[data-addon-toggle]')

          function updateAddonUrl(addonSku) {
            const url = new URL(window.location.href);

            if(addonSku){
              url.searchParams.set('addon', addonSku);
            }else{
              url.searchParams.delete('addon');
            }

            window.history.replaceState(window.history.state, '', url);
            updateShareButtonUrl(url.href);
          }

          function updateShareButtonUrl(url) {
            document.querySelectorAll('share-button').forEach(function(shareButton){
              if(typeof shareButton.updateUrl === 'function'){
                shareButton.updateUrl(url);
                return;
              }

              shareButton.urlToShare = url;
              const shareInput = shareButton.querySelector('input');
              if(shareInput){
                shareInput.value = url;
              }
            })
          }

          if($mainSku){
            $mainSku.addEventListener('change', function(elm){
              window.location.href = '/products/' + $mainSku.value
            })
          }
          if($addonSku){
            $addonSku.addEventListener('change', function(elm){
              updateAddonUrl($addonSku.value);

              let addonCombinations = COMBINATIONS.filter(combination => {
                return combination.addon_sku === $addonSku.value || combination.main_sku === $addonSku.value;
              })
              
              if(addonCombinations.length){
                $combinationModalImage.src = addonCombinations[0].image+'&width=600';
                $combinationModalThumbnails.innerHTML = '';
                $combinationModalThumbnails.classList.add('hidden')
                if(addonCombinations.length > 1){
                  addonCombinations.forEach((combination, index) => {
                    let thumbnailImg = document.createElement('img');
                    thumbnailImg.src = combination.image+'&width=600';
                    thumbnailImg.classList.add('bg-white')
                    if(index == 0){
                      thumbnailImg.classList.add('selected')
                    }
                    $combinationModalThumbnails.appendChild(thumbnailImg);
                    thumbnailImg.addEventListener('click', function(){
                      $combinationModalThumbnails.querySelector('.selected').classList.remove('selected');
                      thumbnailImg.classList.add('selected');
                      $combinationModalImage.src = thumbnailImg.src;
                    })
                  })
                  $combinationModalThumbnails.classList.remove('hidden')
                }
                $combinationModal.classList.remove('hidden')
              }else{
                $combinationModal.classList.add('hidden')
              }
              $bottom_addonSku.forEach(function($elm_addon){
                $elm_addon.classList.remove('selected-addon')
              })
              document.querySelectorAll('[data-addon-sku-bottom="'+$addonSku.value+'"]').forEach(elm => {
                elm.classList.add('selected-addon')
              })

              document.querySelector('.scroll-item[data-addon-sku-bottom="'+$addonSku.value+'"]')?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start"  });
            })
          }

          $bottom_addonSku.forEach(function($elm){
            $elm.addEventListener('click', function(elm){

              let addonSku = $elm.getAttribute('data-addon-sku-bottom');
              let addonCombinations = COMBINATIONS.filter(combination => {
                return combination.addon_sku === addonSku || combination.main_sku === addonSku;
              })
              
              if(addonCombinations.length && !$elm.classList.contains('selected-addon')){
                $combinationModalImage.src = addonCombinations[0].image+'&width=600';
                $combinationModalThumbnails.innerHTML = '';
                $combinationModalThumbnails.classList.add('hidden')
                if(addonCombinations.length > 1){
                  addonCombinations.forEach((combination, index) => {
                    let thumbnailImg = document.createElement('img');
                    thumbnailImg.src = combination.image+'&width=600';
                    thumbnailImg.classList.add('bg-white')
                    if(index == 0){
                      thumbnailImg.classList.add('selected')
                    }
                    $combinationModalThumbnails.appendChild(thumbnailImg);
                    thumbnailImg.addEventListener('click', function(){
                      $combinationModalThumbnails.querySelector('.selected').classList.remove('selected');
                      thumbnailImg.classList.add('selected');
                      $combinationModalImage.src = thumbnailImg.src;
                    })
                  })
                  $combinationModalThumbnails.classList.remove('hidden')
                }

                if($addonSku){
                  $addonSku.value = addonSku;
                  updateAddonUrl(addonSku);
                }

                $combinationModal.classList.remove('hidden')
                
              }else{
                if($addonSku){
                  $addonSku.value = '';
                  updateAddonUrl('');
                }
              
                $combinationModal.classList.add('hidden')

                
              }

              if(!$elm.classList.contains('scroll-item') && document.querySelector('.scroll-item[data-addon-sku-bottom="'+addonSku+'"]')){
                document.querySelector('.scroll-item[data-addon-sku-bottom="'+addonSku+'"]').scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start"  });
              }

              
              $bottom_addonSku.forEach(function($elm_addon){
                if($elm_addon.getAttribute('data-addon-sku-bottom') == addonSku){
                  $elm_addon.classList.toggle('selected-addon')
                }else{
                  $elm_addon.classList.remove('selected-addon')
                }
                
              })

              document.querySelector('[data-addons-modal]').classList.add('hidden')
            })
          })

          if($combinationReset){
            $combinationReset.addEventListener('click', function(elm){

              $addonSku.value = '';
              updateAddonUrl('');
              
              $bottom_addonSku.forEach(function($elm_addon){
                $elm_addon.classList.remove('selected-addon')
              })

              $combinationModal.classList.add('hidden')
            })
          }

          if($combinationToggle){
            $combinationToggle.addEventListener('change', function(elm){
              if(!$combinationToggle.checked){
                  $addonSku.value = '';
                  updateAddonUrl('');
                  $bottom_addonSku.forEach(function($elm_addon){
                    $elm_addon.classList.remove('selected-addon')
                  })
                  $combinationModal.classList.add('hidden')
                  document.querySelector('[data-addon-wrapper]').classList.add('invisible')
                  document.querySelector('[data-addons-list]').classList.add('hidden')
              }else{
                  document.querySelector('[data-addon-wrapper]').classList.remove('invisible')
                  document.querySelector('[data-addons-list]').classList.remove('hidden')
              }
            })
          }

          if($addonSku){
            let addonParam = new URLSearchParams(window.location.search).get('addon');
            if(addonParam){
              addonParam = addonParam.trim();

              let addonOption = Array.from($addonSku.options).find(option => option.value === addonParam);
              if(addonOption){
                $addonSku.value = addonOption.value;

                if($combinationToggle){
                  $combinationToggle.checked = true;
                }

                document.querySelector('[data-addon-wrapper]')?.classList.remove('invisible');
                document.querySelector('[data-addons-list]')?.classList.remove('hidden');
                $addonSku.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }

          function resizeSelect(select) {
            const temp = document.createElement("span");
            temp.style.visibility = "hidden";
            temp.style.whiteSpace = "nowrap";
            temp.style.font = window.getComputedStyle(select).font;
            temp.textContent = select.options[select.selectedIndex].text;

            document.body.appendChild(temp);
            select.style.width = temp.offsetWidth + 30 + "px"; // 30px padding for arrow
            document.body.removeChild(temp);
          }
            
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
